"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Features = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Features_style_1 = require("./Features.style");
const features = [
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "recruitment.features.feature_1_headline" }),
        image: 'recruiting-1',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "recruitment.features.feature_1_body" }),
    },
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "recruitment.features.feature_2_headline" }),
        image: 'searching-network',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "recruitment.features.feature_2_body" }),
    },
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "recruitment.features.feature_3_headline" }),
        image: 'coworkers-2',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "recruitment.features.feature_3_body" }),
    },
];
const Features = () => {
    return ((0, jsx_runtime_1.jsx)(Features_style_1.StyledFeatures, { children: features.map(item => {
            return ((0, jsx_runtime_1.jsxs)(Features_style_1.Box, { children: [(0, jsx_runtime_1.jsx)(Features_style_1.Picture, { children: (0, jsx_runtime_1.jsx)("img", { src: `/media/illustrations/streamline-icon-${item.image}.svg`, alt: "" }) }), (0, jsx_runtime_1.jsxs)(Features_style_1.Content, { children: [(0, jsx_runtime_1.jsx)("dt", { children: item.name }), (0, jsx_runtime_1.jsx)("dd", { children: item.text })] })] }, item.image));
        }) }));
};
exports.Features = Features;
